import React, { useMemo } from "react";

const NaturalPersonIcon = ({ width = 25, height = 23 }) => {
  const svgContent = useMemo(() => {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={width}
        height={height}
        viewBox="0 0 14.883 16.681"
      >
        <path
          id="user-svgrepo-com_1_"
          data-name="user-svgrepo-com (1)"
          d="M135.192,72.39a3.6,3.6,0,1,0-3.6-3.6A3.6,3.6,0,0,0,135.192,72.39Zm0,1.2a4.794,4.794,0,1,1,4.794-4.794A4.794,4.794,0,0,1,135.192,73.589Zm5.993,5.993v-1.8a1.8,1.8,0,0,0-1.8-1.8H131a1.8,1.8,0,0,0-1.8,1.8v1.8a.6.6,0,0,1-1.2,0v-1.8a3,3,0,0,1,3-3h8.39a3,3,0,0,1,3,3v1.8a.6.6,0,1,1-1.2,0Z"
          transform="translate(-127.75 -63.75)"
          fill="#707070"
          stroke="#707070"
          strokeWidth="0.5"
        />
      </svg>
    );
  }, []);

  return svgContent;
};

export default NaturalPersonIcon;



// WEBPACK FOOTER //
// ./src/assets/NaturalPersonIcon.jsx